var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":"https://xdwlgl.ysy.crtvup.com.cn","frameborder":"0","width":"100%","height":_vm.windowHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }